export default __webpack_public_path__ + "e84b216351328640bd6808a7fabbf7eb.png";